import { inject } from '@angular/core';
import { AbstractControl, ValidationErrors } from '@angular/forms';
import { FormModel, SeahorseFormBuilder } from '@seahorse/forms';

export type FolderStructureForm = FormModel<typeof createFolderStructureForm>;

export function createFolderStructureForm() {
  const fb = inject(SeahorseFormBuilder);

  return fb.group({
    folderName: fb.control<string>(null, [folderNameValidator]),
  });
}

export function folderNameValidator(
  control: AbstractControl
): ValidationErrors | null {
  const value = control.value;
  if (!value) return null;
  const pattern = /^[a-zA-Z0-9\-_~/]+$/;
  return pattern.test(value) ? null : { folder: true };
}
